export default "__VITE_ASSET__CNHmpVla__"